import React, { ReactNode } from "react";
interface DividerProps {
  bgColor?: string;
}
const GreyHorizontalDivider: React.FC<DividerProps> = ({
  bgColor = "#c5c5c5", // default color
}) => {
  return (
    <div
      style={{
        height: "1px",
        backgroundColor: bgColor,
        width: "100%",
      }}
    />
  );
};


export default GreyHorizontalDivider;
